namespace Matrix.Data {
    export class TestGroupTestsColumns {
        static columnsKey = 'Data.TestGroupTests';
    }
}
